export function addressToHumanReadableString(address) {
	let str = '';

	if (address.street) {
		str += address.street + ' ';
	}

	if (address.number) {
		str += address.number;
	}

	if (address.suffix) {
		str += address.suffix;
	}

	return str;
}
